//--------------------------------------------------------------------------------------------------

var themes = {}

//--------------------------------------------------------------------------------------------------

themes.white = {
		
  primary:     '#333',     primary_text:    '#FFF',
  secondary:   '#DDD',     secondary_text:  '#333',
  tertiary: 	 '#777',     tertiary_text: 	 '#333',

  success: 		 '#789C7D',     success_text: 	 '#fff',
  warning: 		 '#EED471',     warning_text: 	 '#000',
  danger: 		 '#DE7D73',     danger_text: 		 '#fff',

  body_bgcolor: '#EEE',
  body_textcolor: '#333',
  
  leftbar_bgcolor: '#fff',
  leftbar_textcolor: '#333',
  leftbar_iconcolor: '#333',

  box_bgcolor: '#fff',
  box_textcolor: '#333',

  box_header_bgcolor: '#FFF',
  box_header_textcolor: '#333',

  input_bgcolor: '#EEE',
  input_textcolor: '#333',

  table_stripe_color: '#EEEE',

  filterbtn_textcolor: '#333',
  filterbtn_linecolor: '#777',

}

//--------------------------------------------------------------------------------------------------

themes.cream = {
		
  primary:     '#333',     primary_text:    '#FFF',
  secondary:   '#DDD',     secondary_text:  '#333',
  tertiary: 	 '#777',     tertiary_text: 	 '#333',

  success: 		 '#789C7D',     success_text: 	 '#fff',
  warning: 		 '#EED471',     warning_text: 	 '#000',
  danger: 		 '#DE7D73',     danger_text: 		 '#fff',

  body_bgcolor: '#BEAEA1',
  body_textcolor: '#333',
  
  leftbar_bgcolor: '#DED7D0',
  leftbar_textcolor: '#333',
  leftbar_iconcolor: '#333',

  box_bgcolor: '#F7F5F3',
  box_textcolor: '#333',

  box_header_bgcolor: '#EFEBE8',
  box_header_textcolor: '#333',

  input_bgcolor: '#E6E1DC',
  input_textcolor: '#333',

  table_stripe_color: '#EFEBE8',

  filterbtn_textcolor: '#333',
  filterbtn_linecolor: '#777',

}

//--------------------------------------------------------------------------------------------------

themes.dark = {
		
  primary:     '#fff',     primary_text:    '#333',
  secondary:   '#333',     secondary_text:  '#fff',
  tertiary: 	 '#777',     tertiary_text: 	 '#fff',

  success: 		 '#789C7D',     success_text: 	 '#fff',
  warning: 		 '#EED471',     warning_text: 	 '#000',
  danger: 		 '#DE7D73',     danger_text: 		 '#fff',

  body_bgcolor: '#222',
  body_textcolor: '#fff',
  
  leftbar_bgcolor: '#333',
  leftbar_textcolor: '#fff',
  leftbar_iconcolor: '#CCC',

  box_bgcolor: '#333',
  box_textcolor: '#fff',

  box_header_bgcolor: '#111',
  box_header_textcolor: '#fff',

  input_bgcolor: '#222',
  input_textcolor: '#fff',

  table_stripe_color: '#222',

  filterbtn_textcolor: '#fff',
  filterbtn_linecolor: '#777',

}

//--------------------------------------------------------------------------------------------------

  export default themes



// WEBPACK FOOTER //
// ./src/themes.js